import { Flex, Tooltip } from '@chakra-ui/react';
import { useGetLastRefreshTimeQuery } from '@/store/query/ats-reports';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { KText } from '@/ui-library/components/text';
import { ClockRefresh } from '@kula-ai/icons-core';
import { useDateFormat } from '@/hooks';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';

export const LastRefreshedTime = ({
  scope = 'applications',
}: {
  scope: string;
}) => {
  const { isLoading, data } = useGetLastRefreshTimeQuery({ scope });

  const { dateFormat, timeFormat, currUserTimezone } = useDateFormat();

  const timezoneAbbr =
    TIME_ZONE_CONSTANTS[currUserTimezone]?.abbreviation || 'UTC';

  const date = useMemo(() => {
    if (isLoading) return;
    const timestamp = data?.[0]?.timestamp;
    if (!timestamp) return null;

    return moment(timestamp)
      .tz(currUserTimezone)
      .format(`${dateFormat.value}, ${timeFormat}`);
  }, [data, isLoading, dateFormat, timeFormat, currUserTimezone]);

  const tooltipLabel = `Last refreshed at: ${date} ${timezoneAbbr}` ?? 'NA';

  return (
    <Tooltip minW="fit-content" label={isLoading ? undefined : tooltipLabel}>
      <Flex
        bg="secondary-50"
        p="4px 8px"
        alignItems="center"
        gap="6px"
        borderRadius="sm"
        flexShrink={0}
        w="fit-content"
        h="26px"
      >
        <ClockRefresh size={16} />
        <KText size="sm-medium" color="secondary-700" h="20px">
          {isLoading ? 'Loading...' : `${date} ${timezoneAbbr}` ?? 'NA'}
        </KText>
      </Flex>
    </Tooltip>
  );
};
